export const environment = {
  production: false,
  ymunityApiUrl: "https://test2-api.ymunity.com.br/api",
  recaptchaPublicKey: "6LeSMxkpAAAAAMy7sGycRdjr_fW1YTacfxPsTnM2",
  enableHotjarTracking: false,
  hotjarId: "",
  hotjarVersion: "6",
  analyticsId: "G-JC3PC2LBGN",
};
